import { render, staticRenderFns } from "./mesbrasil.vue?vue&type=template&id=4bd56b55&scoped=true"
import script from "./mesbrasil.vue?vue&type=script&lang=js"
export * from "./mesbrasil.vue?vue&type=script&lang=js"
import style0 from "./mesbrasil.vue?vue&type=style&index=0&id=4bd56b55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd56b55",
  null
  
)

export default component.exports